import { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

interface ArticleFAQProps {
  faq: FAQItem[];
}

export default function ArticleFAQ({ faq }: ArticleFAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIndex((prev) => (prev === i ? null : i));

  return (
    <section className="mt-14 mb-2">
      {/* Section header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#C9A227]/10">
          <i className="ri-question-answer-line text-[#C9A227] text-base"></i>
        </div>
        <h2 className="text-lg font-extrabold text-[#222831] tracking-tight">
          People Also Ask
        </h2>
        <span className="text-xs text-[#3A506B]/40 font-medium">
          {faq.length} questions
        </span>
      </div>

      {/* Accordion list */}
      <div className="flex flex-col divide-y divide-[#E8ECF0] border border-[#E8ECF0] rounded-2xl overflow-hidden">
        {faq.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i} className={`transition-colors ${isOpen ? "bg-[#FAFAFA]" : "bg-white hover:bg-[#FAFAFA]"}`}>
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-start justify-between gap-4 px-6 py-5 text-left cursor-pointer group"
                aria-expanded={isOpen}
              >
                <span
                  className={`text-sm font-semibold leading-snug transition-colors ${
                    isOpen ? "text-[#C9A227]" : "text-[#222831] group-hover:text-[#C9A227]"
                  }`}
                >
                  {item.question}
                </span>
                <span
                  className={`w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5 rounded-full transition-all ${
                    isOpen
                      ? "bg-[#C9A227] text-white rotate-45"
                      : "bg-[#E8ECF0] text-[#3A506B] group-hover:bg-[#C9A227]/15 group-hover:text-[#C9A227]"
                  }`}
                >
                  <i className="ri-add-line text-xs"></i>
                </span>
              </button>

              {/* Collapsible answer */}
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-6 pb-5">
                  <div className="pl-0 border-l-2 border-[#C9A227]/30 pl-4">
                    <p className="text-sm text-[#3A506B] leading-[1.8]">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}